/** Hinweise aus den Download-Headern lesen (pure). */
export function hinweiseAusHeader(wert: unknown): string[] {
  if (typeof wert !== 'string' || wert === '') return [];
  try {
    const roh = JSON.parse(decodeURIComponent(wert));
    return Array.isArray(roh) ? roh.map(String) : [];
  } catch {
    return [];
  }
}

/** Anzahl der nicht mitgesendeten Hinweise (`X-Daily-Order-Hinweise-Weitere`), sonst 0. */
export function weitereAusHeader(wert: unknown): number {
  const n = Number(wert);
  return Number.isInteger(n) && n > 0 ? n : 0;
}
